// extracted by mini-css-extract-plugin
module.exports = {"errorPage":"ErrorPage_errorPage__RqvgU","container":"ErrorPage_container__TLQQg","title":"ErrorPage_title__DPP0u","subTitle":"ErrorPage_subTitle__9uwTi"};